export default __webpack_public_path__ + "static/media/login-bg-2.16381e6f.jpg";